<template>
  <!--  个人信息收集清单-->
  <div class="wrapper">
    <div style="text-align: center; font-weight: bold; margin: 0.16rem">
      收集个人信息明示清单
    </div>
    <br />
    <p>
      为更好地为您提供服务，山东一卡通APP将遵循国家相关法律法规的规定和您的同意，收集您的个人信息。&nbsp;为了便于您了解您在使用我们的服务时，我们需要收集的信息类型与用途，我们会结合具体服务向您逐一说明。
    </p>
    <br />
    <table>
      <thead>
        <tr>
          <td scope="col">
            <p><strong>业务场景</strong></p>
          </td>
          <td scope="col" style="width: 50%">
            <p><strong>收集目的</strong></p>
          </td>
          <td scope="col">
            <p><strong>个人信息字段</strong></p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="4">
            <p>注册信息</p>
          </td>
          <td rowspan="2">
            <p>
              您提交的手机号码用于您注册、绑定账户、密码找回时接收验证码，并且作为您与我们指定的联系方式之一，用来接收活动提醒、服务消息、账户消息、公告消息业务通知等
            </p>
          </td>
          <td>
            <p>用户名</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>手机号码</p>
          </td>
        </tr>

        <tr>
          <td rowspan="2">
            <p>
              您注册使用山东一卡通APP相关服务时，用于您注册、绑定账户、密码找回时接收验证码，并且作为您与我们指定的联系方式之一，用来接收相关业务通知（包括新品上线、活动提醒、服务变更、服务相关通知）
            </p>
          </td>
          <td>
            <p>用户名</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>手机号码</p>
          </td>
        </tr>

        <tr>
          <td rowspan="2">
            <p>登录信息</p>
          </td>
          <td rowspan="2">
            <p>
              当您在使用山东一卡通APP客户端登录时，为了保证登录服务正常运行，验证使用设备及登录身份的合法性和安全性，我们需要访问您的本机号码.
            </p>
          </td>
          <td>
            <p>用户名</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>手机号码</p>
          </td>
        </tr>
        <tr>
          <td rowspan="6">
            <p>个人实名认证</p>
          </td>
          <td rowspan="6">
            <p>
              在使用山东一卡通APP购卡服务和购买商品等服务时，为确保实名认证的准确性和支付安全性，您需要完成实名认证
            </p>
          </td>
          <td>
            <p>姓名</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>手机号码</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>身份证信息</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>省、市、区地址信息</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>面部信息</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>职业</p>
          </td>
        </tr>

        <tr>
          <td rowspan="2">
            <p>密码重置、密码找回</p>
          </td>
          <td rowspan="2">
            <p>用于用户将密码重置或找回密码场景</p>
          </td>
          <td>
            <p>用户名</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>手机号码</p>
          </td>
        </tr>
        <tr>
          <td rowspan="5">
            <p>支付信息</p>
          </td>
          <td rowspan="5">
            <p>
              以满足您的充值，消费和产品订购支付需求，支持微信、支付宝和扫码支付
            </p>
          </td>
          <td>
            <p>银行账户信息</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>发票信息</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>姓名</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>手机号</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>地址信息</p>
          </td>
        </tr>
        <tr>
          <td rowspan="11">
            <p>运营与安全保障</p>
          </td>
          <td rowspan="11">
            <p>日志信息、设备或软件信息</p>
          </td>
          <td>
            <p>搜索关键字</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>访问页面</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>IP地址</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>浏览器的类型</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>浏览器配置信息</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>电信运营商</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>使用的语言</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>访问日期和时间</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>软硬件特征信息</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>手机机型</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>其他软件配置信息</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>订单信息</p>
          </td>
          <td>
            <p>方便您查找您的订购历史</p>
          </td>
          <td>
            <p>购买记录</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>其他信息</p>
          </td>
          <td>
            <p>
              当您参加山东一卡通APP特定服务优惠活动时，为便于您参加相关活动，必须收集的特定身份的认证信息，以便更好得服务
            </p>
          </td>
          <td>
            <p>特定身份的认证信息</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p>&nbsp;</p>
<!--    <div class="btn-wrap">-->
<!--      <button class="jump-btn" @click="goPersonInfoCopy">个人信息收集情况</button>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'PersonInfo',
  data() {
    return {}
  },
  created() {},
  methods: {
    goPersonInfoCopy() {
      this.$router.push('/personInfoCopy')
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  padding: 0 0.16rem;
  text-align: left;
  background-color: white;
  line-height: 1.5;
  font-size: 0.16rem;
  color: #333333;
  /* 表格边框 */
  table {
    width: 100%;
    border-collapse: collapse;
  }

  table td,
  table th {
    border: 0.01rem rgba(0, 0, 0, 0.08) solid;
    padding: 0.1rem;
    font-size: 0.14rem;
    vertical-align: middle;
  }

  table th {
    width: 20%;
    background-color: rgba(0, 0, 0, 0.03);
  }

  .btn-wrap {
    padding: 0.2rem 0.1rem;
  }

  .jump-btn {
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
    text-align: center;
    background-color: #ffffff;
    border: 0.01rem solid #3180ff;
    border-radius: 0.25rem;
    color: #3180ff;
    font-size: 0.16rem;
    font-weight: bold;
    outline: none;
    cursor: pointer;
  }
}
</style>
